import {api} from "@/store/resources";

export default {
    namespaced: true,
    state: {
        goals: {
            data: [],
            dirty: true
        },
        goalsImages: []
    },
    getters: {
        goalsList: (state) => {
            return [...state.goals.data];
        },
        goalTypeList: () => ([
            {name_en: 'Cumulative', name_ru: 'Накопительный', id: 1}, {name_en: 'Credit', name_ru: 'Кредитный', id: 2}
        ]),
        goalsImages: (state) => state.goalsImages,
    },
    actions: {
        createNewGoal({}, data) {
            return api.goals.save(data)
        },
        updateGoal({}, data) {
            return api.goals.update({id: data.id}, {...data})
        },
        completeGoal({}, {id, ...data}) {
            return api.goal_close.save({id}, data)
        },
        deleteGoal({}, {id, ...data}) {
            return api.goals.delete({id}, data)
        },
        getGoalChartData({}, goal_id) {
            return api.goals_chart_data.get({goal_id})
        },
        async fetchUserGoals({rootState, commit}) {
            try {
                const space_id = rootState.space.current_space.data.id;
                const res = await api.goals.get({space_id, status: [1, 2]});
                if (res.body.success) {
                    commit('storeUserGoals', res.body.data.rows);
                }
            } catch (err) {
                console.error(err)
            }
        },

        async fetchUploadedGoalsImages({rootState, commit}) {
            try {
                const space_id = rootState.space.current_space.data.id;
                const res = await api.goals_covers.get({space_id})
                if (res.body.success) {
                    commit('setGoalsImages', res.body.data);
                }
            } catch (err) {
                console.error(err)
            }

        },
        uploadGoalImage({}, data) {
            return api.goals_upload_image.save(data)
        },

        replenishGoalBalance({}, {goal_id, ...data}) {
            return api.goal_replenish_balance.save({goal_id}, data);
        }
    },
    mutations: {
        setUserGoalsDirty(state, dirty = true) {
            state.goals.dirty = dirty;
        },
        storeUserGoals(state, data) {
            state.goals.dirty = false;
            state.goals.data = data;
        },
        setGoalsImages(state, data) {
            state.goalsImages = data;
        },
        pushUploadedGoalsImages(state, imageData) {
            if (state.goalsImages.includes(imageData)) return
            state.goalsImages.push(imageData);
        },
        clearGoals(state) {
            state.goals.dirty = true;
            state.goals.data = [];
        }
    },
}